<template>
    <div class="my-12">
        <div v-if="dataLoaded">
            <Latest-publication-list-classic v-if="model.view === 'classic'" :results="results" :model="model" />
            <Latest-publication-list-modern v-if="model.view === 'modern'" :results="results" :model="model" />
        </div>
        <div v-else>
            <LoadingSpinner size="2x" />
        </div>
        <div v-if="error">Noe gikk galt</div>
    </div>
</template>

<script>
import api from '@/Scripts/api/api';
import LoadingSpinner from '@/Scripts/components/atoms/LoadingSpinner/loadingSpinner.vue';
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import LatestPublicationListClassic from '@/Scripts/components/blocks/LatestPublicationsBlock/LatestPublicationListClassic.vue';
import LatestPublicationListModern from '@/Scripts/components/blocks/LatestPublicationsBlock/LatestPublicationListModern.vue';

export default {
    props: ['model'],
    components: {
        LoadingSpinner,
        EpiLink,
        LatestPublicationListClassic,
        LatestPublicationListModern
    },
    data() {
        return {
            dataLoaded: false,
            error: false,
            results: []
        };
    },
    created() {
        this.getLatestPublications(this.model);
    },
    methods: {
        getLatestPublications(model) {
            const parameters = {
                size: model.numberOfItems ? model.numberOfItems : 8,
                page: 1,
                siteid: this.$store.getters.getSiteId
            };
            api.getLatestPublicationsForStartPage(parameters).then(response => {
                const self = this;
                self.dataLoaded = true;
                self.results = response.data.Hits;
            });
        }
    }
};
</script>
